import _regeneratorRuntime from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import { invokeApi, resetData } from "@/utils/shared";
import { getKanbanData, getPatientDetail } from "@/api/yewu";
import { getWarnIndexStatisticsList } from "@/api/health";
import { LeftPanel, MIDivision, PatientDivision, FollowUp, EvalidatePlace, EvalidateCycle, CardPanel, KNDict, Pressure } from "./components";
export default {
  name: "VisualizationPanel",
  components: {
    LeftPanel: LeftPanel,
    MIDivision: MIDivision,
    PatientDivision: PatientDivision,
    FollowUp: FollowUp,
    EvalidatePlace: EvalidatePlace,
    EvalidateCycle: EvalidateCycle,
    CardPanel: CardPanel,
    KNDict: KNDict,
    Pressure: Pressure
  },
  created: function created() {
    this.getData();
  },
  data: function data() {
    return {
      id: 1,
      patientTable: {
        rowNum: 12,
        oddRowBGC: "transparent",
        evenRowBGC: "transparent",
        headerBGC: "transparent",
        align: ["center", "center", "center", "center"],
        columnWidth: [80, 60, 60, 90],
        header: ["姓名", "性别", "年龄", "手机号"],
        data: []
      },
      idxsTable: {
        oddRowBGC: "transparent",
        evenRowBGC: "transparent",
        headerBGC: "transparent",
        align: ["center", "center", "center", "center"],
        header: ["指标名称", "评估总人数", "正常人数", "异常人数"],
        data: []
      },
      patientDetailVisible: false,
      source: {},
      detail: {}
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, idxRes, patientcols, idxCols, total, nanScore;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return invokeApi(getKanbanData, {});
            case 2:
              res = _context.sent;
              _context.next = 5;
              return invokeApi(getWarnIndexStatisticsList, {
                pageNum: 1,
                pageSize: 9999
              });
            case 5:
              idxRes = _context.sent;
              patientcols = ["patientName", "patientSex", "patientAge", "patientPhone"];
              _this.patientTable = _objectSpread(_objectSpread({}, _this.patientTable), {}, {
                data: res.data.patientKanBanVoList.map(function (it) {
                  return patientcols.map(function (key) {
                    return it[key] || "-";
                  });
                })
              });
              idxCols = ["temName", "allPeople", "normal", "highRisk"];
              _this.idxsTable = _objectSpread(_objectSpread({}, _this.idxsTable), {}, {
                data: idxRes.data.obj.map(function (it) {
                  return idxCols.map(function (key) {
                    return it[key] || "-";
                  });
                })
              });
              total = res.data.nan + res.data.nv;
              nanScore = parseInt(res.data.nan / total * 10000);
              Object.assign(res.data, {
                nanScore: nanScore / 100,
                nvScore: (10000 - nanScore) / 100
              });
              _this.source = res.data;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    showPatientDetail: function showPatientDetail(it) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              console.log(it, "showPatientDetail");
              _context2.next = 3;
              return invokeApi(getPatientDetail, _this2.source.patientKanBanVoList[it.rowIndex].patientCode);
            case 3:
              res = _context2.sent;
              _this2.detail = Object.assign(res.data, _this2.source.patientKanBanVoList[it.rowIndex]);
              _this2.patientDetailVisible = true;
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    reset: function reset() {
      resetData(this.params);
      this.tableData.page.pageNum = 1;
      this.getData();
    },
    setRem: function setRem() {
      // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
      var scale = document.documentElement.clientWidth / 1920; //当前设计稿为1920  如果是750则 替换为 750
      // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
      document.documentElement.style.fontSize = 16 * Math.min(scale, 2) + "px";
      this.id++;
    }
  },
  mounted: function mounted() {
    this.setRem();
    window.addEventListener("resize", this.setRem);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.setRem);
  }
};